import searchItemUrl from '../utils/searchItemUrl';

const querySuggestionsItemTemplate = (html, children, query) => {
	return html` <a class="aa-ItemLink" href=${searchItemUrl(query)}>
		${children}
	</a>`;
};

export default querySuggestionsItemTemplate;
